export default __webpack_public_path__ + "static/media/icon.10aec0ab.svg";